import axios from 'axios'
import { TypeCodeOption } from 'src/viewModels/workflow/TypeCodeOption'
import { ReferralSourceOption } from 'src/viewModels/workflow/ReferralSourceOption'
import { ReferralSourceContactOption } from 'src/viewModels/workflow/ReferralContactOption'
import { MedicalProviderOption } from 'src/viewModels/workflow/MedicalProviderOption'
import { ReferralSourceContactTypeOption } from 'src/viewModels/workflow/ReferralSourceContactTypeOption'

const base_url = process.env.REACT_APP_BASE_URL || 'http://localhost:5000'

export async function getInvoiceTypeCodeOptions(): Promise<TypeCodeOption[]> {
  const url = `${base_url}/api/Lookup/invoice-type-code-options`
  const response = await axios.get<TypeCodeOption[]>(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export async function getReferralSourceOptions(): Promise<ReferralSourceOption[]> {
  const response = await axios.get<ReferralSourceOption[]>(
    `${base_url}/api/Lookup/referral-source-options`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export async function getReferralContactOptions(
  id: string | null
): Promise<ReferralSourceContactOption[]> {
  const response = await axios.get<ReferralSourceContactOption[]>(
    `${base_url}/api/Lookup/referral-source/${id}/contact-options`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export async function getMedicalProviderOptions(): Promise<MedicalProviderOption[]> {
  const response = await axios.get<MedicalProviderOption[]>(
    `${base_url}/api/Lookup/medical-provider-options`,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response.data
}

export async function getReferralSourceContactTypeOptions(): Promise<
  ReferralSourceContactTypeOption[]
> {
  const url = `${base_url}/api/Lookup/referral-source-contact-type-options`
  const response = await axios.get<ReferralSourceContactTypeOption[]>(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}
